// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 169 ? "3fb82539" : chunkId) + "." + {"52":"baf1fadf65109947","139":"e0b8da9815ba2cf2","169":"6681523b32e968dd","865":"b9af73baa5192270"}[chunkId] + ".js";
};